import { useMemo } from "react";

export const constructObjectFromDiff = (diffObject, prevOrNext) => {
  const obj = {};
  Object.entries(diffObject).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (prevOrNext === 'prev') {
        if (value?.length === 1) obj[key] = {};
        else if (value?.length === 2) obj[key] = value[0];
        else if (value?.length === 3 && value?.[2] === 0) obj[key] = value[0];
      } else {
        if (value?.length === 1) obj[key] = value[0];
        else if (value?.length === 2) obj[key] = value[1];
      }
      // if value is not an array, check if it is object
    } else if (value?._t !== 'a' && typeof value === 'object') {
      obj[key] = constructObjectFromDiff(value, prevOrNext)
      // If value is not an array and it is not an object => then it's value (by key) probably an array;
    } else if (value?._t === 'a' && typeof value === 'object') {
      if (prevOrNext === 'prev') {
        obj[key] = Object.entries(value).map(([aKey, aValue]) => {
          if (aKey === '_t') return null;

          if (aKey.startsWith('_') && Array.isArray(aValue)) {
            if (aValue?.[2] === 0) return [aKey, aValue[0]]
            if (aValue?.[2] === 3) return null;
            return null;
          } else {
            if (Array.isArray(aValue)) {
              if (aValue.length === 2) return [aKey, aValue[0]]
              if (aValue.length === 1) return [aKey, {}]
              return null;
            } else if (!!aValue && typeof aValue === 'object') {
              return [aKey, constructObjectFromDiff(aValue, prevOrNext)];
            }
          }
        }).filter(v => !!v);
      } else {
        obj[key] = Object.entries(value).map(([aKey, aValue]) => {
          if (/^\d*$/.test(aKey)) {
            if (Array.isArray(aValue)) {
              if (aValue?.length === 2) return [aKey, aValue[1]]
              else if (aValue?.length === 1) return [aKey, aValue[0]];
              return null;
            } else if (!!aValue && typeof aValue === 'object') {
              return [aKey, constructObjectFromDiff(aValue, prevOrNext)];
            }
          }
        }).filter(v => !!v);
      }
    }
  })
  return obj;
}

export const useArrayHistoryChanges = (diffArray) => {
  return useMemo(() => {
    const historyStateItems = diffArray ? Object.entries(diffArray || {}) : undefined;
    const removedItems = historyStateItems?.filter(([key, value]) => {
      if (key === '_t') return false;
      if (/^_\d*$/.test(key) && Array.isArray(value) && value?.[2] === 0) return true; // value has been removed
      if (Array.isArray(value) && value?.length === 1) return false; // value has been added;
      return false;
    }).map(([key, value]) => {
      if (Array.isArray(value) && value?.[2] === 0) return value[0];
      else return constructObjectFromDiff(value, 'prev');
    });
    
    const addedItems = historyStateItems?.filter(([key, value]) => {
      if (key === '_t') return false;
      if (/^_\d*$/.test(key)) return false;
      if (Array.isArray(value) && value?.length === 1) return true;
      return false;
    }).map(([key, value]) => {
      if (Array.isArray(value) && value?.length === 1) return value[0];
      else return constructObjectFromDiff(value, 'next');
    });
  
    // Their prev state, to be able to compare with it
    const changedItems = historyStateItems?.map(([key, value]) => {
      if (key === '_t') return null;
      if (/^_\d*$/.test(key)) return null;
      if (Array.isArray(value) && (value?.length === 1 || value?.length === 3)) return null;
      if (Array.isArray(value) && value?.length === 2) return [key, value[0]];
      if (!Array.isArray(value) && Object.keys(value).length >= 1) {
        return [key, value]; // same id
      }
      return null;
    }).filter((res) => !!res).map(([key, value]) => {
      if (Array.isArray(value) && (value?.length === 2 || value?.length === 3)) return [key, value[0]];
      else return [key, constructObjectFromDiff(value, 'prev')];
    });
  
    return { removedItems: removedItems || [], addedItems: addedItems || [], changedItems: changedItems || [] };
  }, [diffArray])
}